import React, { useState } from 'react';
import { Wrapper, WrapperDiv } from './styles';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useOrderContext } from '../../context/order_context';
import { useCartContext } from '../../context/cart_context';
import { useLanguageContext } from '../../context/language_context';

function ShippingForm({ confirmShipping }) {
  const { t, isArabic } = useLanguageContext();
  const {
    shipping,
    updateShipping,
  } = useOrderContext();
  const { cart } = useCartContext();

  // Local state for the simplified form
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    governorate: '',
    city: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    
    // Also update the order context shipping info
    if (name === 'firstName' || name === 'lastName') {
      updateShipping({
        target: {
          name: 'name',
          value: `${name === 'firstName' ? value : formData.firstName} ${name === 'lastName' ? value : formData.lastName}`.trim()
        }
      });
    } else if (name === 'phone') {
      updateShipping({ target: { name: 'phone_number', value } });
    } else if (name === 'governorate') {
      updateShipping({ target: { name: 'state', value } });
    } else if (name === 'city') {
      updateShipping({ target: { name: 'city', value } });
      updateShipping({ target: { name: 'line1', value } });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.firstName) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!formData.lastName) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!formData.phone || formData.phone.length < 8) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!formData.governorate) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!formData.city) {
      return toast.error(t.toasts.fillAllFields);
    }

    // Update shipping context with all data before confirming
    updateShipping({ target: { name: 'name', value: `${formData.firstName} ${formData.lastName}` } });
    updateShipping({ target: { name: 'phone_number', value: formData.phone } });
    updateShipping({ target: { name: 'state', value: formData.governorate } });
    updateShipping({ target: { name: 'city', value: formData.city } });
    updateShipping({ target: { name: 'line1', value: formData.city } });
    updateShipping({ target: { name: 'country', value: 'TN' } });
    updateShipping({ target: { name: 'postal_code', value: '0000' } });

    return confirmShipping();
  };

  if (cart.length < 1) {
    return (
      <WrapperDiv className='page' style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
        <div className='empty'>
          <h2>{t.cart.empty}</h2>
          <Link to='/products' className='btn'>
            {t.cart.fillCart}
          </Link>
        </div>
      </WrapperDiv>
    );
  }

  return (
    <Wrapper className='page-100' style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <div className='shipping-container'>
        <div className='title'>
          <h2>{t.customerForm.title}</h2>
        </div>
        <form onSubmit={handleSubmit}>
          {/* First Name & Last Name Row */}
          <div className='form-row'>
            <div className='form-group'>
              <label>{t.customerForm.firstName}*</label>
              <input
                type='text'
                name='firstName'
                className='input'
                placeholder={t.customerForm.firstName}
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
            <div className='form-group'>
              <label>{t.customerForm.lastName}*</label>
              <input
                type='text'
                name='lastName'
                className='input'
                placeholder={t.customerForm.lastName}
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Phone */}
          <div className='form-group full-width'>
            <label>{t.customerForm.phone}*</label>
            <input
              type='tel'
              name='phone'
              className='input'
              placeholder={t.customerForm.phonePlaceholder}
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          {/* Governorate & City Row */}
          <div className='form-row'>
            <div className='form-group'>
              <label>{t.customerForm.governorate}*</label>
              <input
                type='text'
                name='governorate'
                className='input'
                placeholder={t.customerForm.governorate}
                value={formData.governorate}
                onChange={handleChange}
              />
            </div>
            <div className='form-group'>
              <label>{t.customerForm.city}*</label>
              <input
                type='text'
                name='city'
                className='input'
                placeholder={t.customerForm.city}
                value={formData.city}
                onChange={handleChange}
              />
            </div>
          </div>

          <button type='submit' className='btn shipping-btn'>
            {t.checkout.placeOrder} ({t.checkout.cashOnDelivery})
          </button>
        </form>
      </div>
    </Wrapper>
  );
}

export default ShippingForm;
